const areaValues = (totalArea, {
  totalAreasMax, totalAreasMin, usableAreasMax, usableAreasMin,
}) => ({
  min: totalArea ? totalAreasMin : usableAreasMin,
  max: totalArea ? totalAreasMax : usableAreasMax,
})

const areaFieldsMapper = (filterForTotalArea, { max, min }) => {
  const totalAreas = {
    usableAreasMin: null,
    usableAreasMax: null,
    totalAreasMin: min,
    totalAreasMax: max,
  }

  const usableAreas = {
    usableAreasMin: min,
    usableAreasMax: max,
    totalAreasMin: null,
    totalAreasMax: null,
  }

  return filterForTotalArea ? totalAreas : usableAreas
}

export {
  areaValues,
  areaFieldsMapper,
}
